import { render, staticRenderFns } from "./ModalEditCurrencyGroup.vue?vue&type=template&id=6f3aa0ec&scoped=true&xmlns=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml&"
import script from "./ModalEditCurrencyGroup.vue?vue&type=script&lang=js&"
export * from "./ModalEditCurrencyGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f3aa0ec",
  null
  
)

export default component.exports